import * as yup from 'yup';
import { RotatingPromoBar } from '@web/molecules';
import { carouselConfigSchema } from '../schemas';
import { schema as rotatingPromoMessageSchema } from './rotating_promo_message';

export const component = RotatingPromoBar;

export const schema = yup
  .object({
    backgroundColor: yup.string(),
    fontColor: yup.string(),
    asCarousel: yup.bool(),
    carouselConfig: yup.object().nullable(),
    sticky: yup.bool(),
    messages: yup.array(rotatingPromoMessageSchema),
  })
  .transform(value => {
    const carouselBlock = value.carousel_config?.[0];
    return {
      backgroundColor: value.background_color || undefined,
      fontColor: value.font_color || undefined,
      asCarousel: carouselBlock?.as_carousel || false,
      carouselConfig: carouselBlock?.as_carousel
        ? carouselConfigSchema.cast(carouselBlock)
        : null,
      sticky: value.sticky || false,
      messages: value.messages || [],
    };
  });
